import { render, staticRenderFns } from "./TabelaUsuario.vue?vue&type=template&id=b49d8408&scoped=true&"
import script from "./TabelaUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaUsuario.vue?vue&type=style&index=0&id=b49d8408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49d8408",
  null
  
)

export default component.exports